// @flow
import * as React from 'react';
import PreviewImages from 'common/components/previewImages/PreviewImages';
import VenueLink from './VenueLink';

import styles from './VenueImage.module.scss';
import type { PreviewVenue } from './types';

export default function VenueImage(props: {|
  onClickVenueLink: void | (() => void),
  openInNewTab: boolean,
  venue: PreviewVenue,
  featuredVenueIcon?: React.Node
|}): React.Node {
  const { venue, onClickVenueLink, openInNewTab, featuredVenueIcon } = props;

  return (
    <div className={styles.imageContainer}>
      {featuredVenueIcon}
      <PreviewImages
        images={venue.preview_images}
        linkWrapper={({ children }) => (
          <VenueLink
            venue={venue}
            openInNewTab={openInNewTab}
            onClickVenueLink={onClickVenueLink}
          >
            {children}
          </VenueLink>
        )}
      />
    </div>
  );
}
